export interface FlowNode {
  role: string;
  label: string;
}

function Arrow() {
  return (
    <span className="flex items-center px-1.5 text-subtle" aria-hidden="true">
      <svg
        viewBox="0 0 22 10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        className="h-2.5 w-5"
      >
        <path d="M0 5h18" strokeLinecap="round" />
        <path d="m15 2 3 3-3 3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

export function TrafficFlowDiagram({
  nodes,
  helperText,
}: {
  nodes: FlowNode[];
  helperText?: string;
}) {
  return (
    <div className="rounded-lg bg-base px-3.5 py-4">
      <div className="overflow-x-auto">
        <ol className="mx-auto flex w-max list-none items-stretch p-0">
          {nodes.map((node, index) => (
            <li key={`${node.label}-${index}`} className="flex items-center">
              <div className="flex min-w-28 flex-col gap-0.5 rounded-lg border border-muted bg-surface px-2.5 py-2">
                <span className="text-2xs uppercase tracking-wider text-foreground/70">
                  {node.role}
                </span>
                <span className="text-sm">{node.label}</span>
              </div>
              {index < nodes.length - 1 && <Arrow />}
            </li>
          ))}
        </ol>
      </div>
      {helperText && (
        <p className="mt-3 text-center text-xs text-foreground/70">
          {helperText}
        </p>
      )}
    </div>
  );
}
